import { PublicQuestion } from "@/queries/types";
import {
  DSPictureOption as SystemPictureOption,
  DSPictureOptionsAnswer as SystemPictureOptionsAnswer,
} from "@hundred5/design-system";
import { Dispatch } from "react";
import * as amplitude from "../../../../amplitude";
import { Action, State } from "../../reducer";
import { sortOptions } from "../utils";

interface Props {
  question: PublicQuestion;
  state: State;
  dispatch: Dispatch<Action>;
}

export function PictureOptionsAnswer({ question, state, dispatch }: Props) {
  const answer = state.answers[question.test_question_id];
  return (
    <SystemPictureOptionsAnswer>
      {sortOptions(question?.options || []).map((option, index) => {
        const optionId = (
          option.test_question_option_id || option.library_question_option_id
        )?.toString();
        return (
          <SystemPictureOption
            key={option.test_question_option_id}
            name={`answer-${question.test_question_id}`}
            id={`option-${question.test_question_id}-${optionId}`}
            selected={answer?.chosenOptions[0]?.optionId === optionId}
            disabled={state.submitting}
            label={`Picture ${index + 1}`}
            url={option.content}
            onChange={(selected) => {
              if (selected && optionId) {
                dispatch({
                  type: "select_single_option_answer",
                  payload: {
                    questionId: question.test_question_id.toString(),
                    optionId: optionId.toString(),
                  },
                });

                amplitude.trackQuestionAnswer(
                  state.jobOpeningSlug,
                  state.activeQuestionIndex,
                );
              }
            }}
          />
        );
      })}
    </SystemPictureOptionsAnswer>
  );
}
